import React from 'react';
import PropTypes from 'prop-types';

import HeaderExtranet from './HeaderExtranet';

const AuthExtranetLayout = ({ children }) => (
  <div id="layout-wrapper">
    <HeaderExtranet />
    <main className="main-content-extranet">
      {children}
    </main>
  </div>
);

AuthExtranetLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthExtranetLayout;
